import { isAuthenticated } from '@/common/utils/routerMixins';
import ActivateCoinAccount from './views/ActivateCoinAccount.vue';
import CommercialResearchList from './views/CommercialResearchList.vue';
import Dashboard from './views/Dashboard.vue';
import ExternalInit from './views/ExternalInit.vue';
import MaxReviews from './views/MaxReviews.vue';
import OrganisationList from './views/OrganisationList.vue';
import OrganisationDetail from './views/OrganisationDetail.vue';
import OwnCommercialMessage from './views/OwnCommercialMessage.vue';
import ProductList from './views/ProductList.vue';
import ResearchAnswerList from './views/ResearchAnswerList.vue';
import ResearchSet from './views/ResearchSet.vue';
import ResearchSetReview from './views/ResearchSetReview.vue';
import ReviewerDashboard from './views/ReviewerDashboard.vue';
import ReviewResearch from './views/ReviewResearch.vue';
import RemovedFromResearchView from './views/RemovedFromResearchView.vue';


export default [
  {
    path: '/dashboard/',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/dashboard/reviewer/',
    name: 'reviewer-dashboard',
    component: ReviewerDashboard,
    beforeEnter: isAuthenticated,
  },
  {
    // View to see answers of a research;
    path: '/res/:uuid/answers/',
    name: 'research-answers',
    component: ResearchAnswerList,
  },
  {
    // View to review a research;
    path: '/res/:uuid',
    name: 'review-research',
    component: ReviewResearch,
    meta: {
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    path: '/res/:uuid/removed/',
    name: 'removed-from-research',
    component: RemovedFromResearchView,
    meta: {
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    // View to see the researches in a research set;
    path: '/research-set/:uuid',
    name: 'research-set',
    component: ResearchSet,
  },
  {
    // View to review research(es) in a research set;
    path: '/research-set/:uuid/review/',
    name: 'research-set-review',
    component: ResearchSetReview,
    meta: {
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    path: '/max-reviews/',
    name: 'max-reviews',
    component: MaxReviews,
    meta: {
      bgClass: 'bg-default-dark',
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    path: '/own-commercial/',
    name: 'own-commercial',
    component: OwnCommercialMessage,
    meta: {
      bgClass: 'bg-default-dark',
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    path: '/organisations/',
    name: 'public-organisation-list',
    component: OrganisationList,
    meta: {
      showBreadcrumbs: true,
    },
  },
  {
    path: '/organisation/:slug/',
    name: 'organisation-detail',
    component: OrganisationDetail,
    meta: {
      showBreadcrumbs: true,
      shareEnabled: true,
    },
  },
  {
    path: '/all-commercials/',
    name: 'commercial-list',
    component: CommercialResearchList,
    meta: {
      showBreadcrumbs: true,
    },
  },
  {
    path: '/activate-coin-account/',
    name: 'activate-coin-account',
    component: ActivateCoinAccount,
  },
  {
    path: '/product-list/',
    name: 'product-list',
    component: ProductList,
    meta: {
      breadCrumbs: 'productList',
    },
  },
  {
    path: '/external-init/',
    name: 'external',
    component: ExternalInit,
  },
  {
    path: '/external/:slug/start/',
    name: 'external',
    component: ExternalInit,
  },
];
